import { gql } from "@apollo/client";

export const UPDATE_BRAND_PURCHASER_STATUS = gql`
  mutation UpdateBrandPurchaserStatus($params: BrandPurchaserStatusInput!) {
    updateBrandPurchaserStatus(params: $params) {
      purchaserId
      purchaserKey
      purchaserName
      purchaserIsActive
      brandPurchaser {
        id
        email
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
        deletedAt
        deletedBy
      }
    }
  }
`;
